import React from 'react';
import UserProfileHealthProDesktopView from './user_profile_health_pro_desktop_view';
import UserProfileEndUserDesktopView from './user_profile_end_user_desktop_view';
import { userIsCreator } from '../../services/users';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const UserProfileDesktopView = () => {
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  return isSmorgStudio ? (
    <UserProfileHealthProDesktopView />
  ) : (
    <UserProfileEndUserDesktopView />
  );
};

export default UserProfileDesktopView;
